export enum InvoicingZone {
  France = 'France',
  EU = 'EU',
  NonEU = 'NonEU'
}
